import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import './styles.css';
import './utils/pwaInstall';
import { registerPwaServiceWorker } from './utils/pwaServiceWorker';
import { PwaUpdateNotice } from './components/PwaUpdateNotice';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HashRouter>
      <App />
      <PwaUpdateNotice />
    </HashRouter>
  </React.StrictMode>
);
registerPwaServiceWorker();